import React from "react";
import "../styles/NewsSection.css";

const NewsSection = () => {
  return (
    <div className="news-section">
      <h2>🔥 News</h2>
      <div className="news-list">
        <p>
          <b>June 2026: </b>One first-author paper accepted at ECCV 2026.
        </p>
        <p>
          <b>June 2026: </b>One paper accepted at IROS 2026.
        </p>
        <p>
          <b>September 2025: </b>One paper accepted at NeurIPS 2025 (Spotlight).
        </p>
        <p>
          <b>March 2025: </b>Happy to start my PhD at the Ommer-Lab.
        </p>
      </div>
    </div>
  );
};

export default NewsSection;
